import React, { useState } from 'react'
import { Authenticator, Text, useTheme, View, Image } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { 
  FAQItem, NavBar, Home, IntentResponse 
} from './ui-components';

// To add GraphQL, based on instructions here https://docs.amplify.aws/lib/graphqlapi/getting-started/q/platform/js/#create-the-graphql-api
import { Amplify, API, AuthModeStrategyType, graphqlOperation } from 'aws-amplify';
import awsconfig from './aws-exports'; 
import * as queries from './graphql/queries';
import * as mutations from './graphql/mutations';
import * as subscriptions from './graphql/subscriptions';

// Adding AG Grid https://ag-grid.com/react-data-grid/getting-started/
import { render } from 'react-dom';
import { AgGridReact } from 'ag-grid-react';
import { Grid } from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css'; // failed to compile unless /dist was included
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';


// Added the authModeStrategyType to allow for both API Key and Cognito with DataStore
// Based on advice from AWS on Discord to use https://docs.amplify.aws/lib/datastore/setup-auth-rules/q/platform/js/#static-group-authorization-with-oidc-provider
Amplify.configure({
  ...awsconfig,
  DataStore: {
    authModeStrategyType: AuthModeStrategyType.MULTI_AUTH
  }
});

// Since I'm having trouble with the Amplify+React components, this is an attempt to write my own
class ClassOwner extends React.Component {
  constructor(props){
    super(props);
    this.state = {OwnerName: "OwnerName Goes Here"};
  }

  async componentDidMount() {
    this.setState({OwnerName: "Loading OwnerName..."});
    try {
      const ownerData = await API.graphql(graphqlOperation(queries.listOwners));
      console.log("ownerData: ", ownerData);
      this.setState({
        OwnerName: ownerData.data.listOwners.items[0].name
      });
    } catch (error) {
      console.log("Error in ClassOwner.componentDidMount: ", error);
    }
  } 

  render() {
    return <Text>{this.state.OwnerName}</Text>;
  }
}


export default function App({ signOut, user }) {

  const [rowData] = useState([
    {make: "Toyota", model: "Celica", price: 35000},
    {make: "Ford", model: "Mondeo", price: 32000},
    {make: "Porsche", model: "Boxster", price: 72000}
    ]);

  const [columnDefs] = useState([
      { field: 'make' },
      { field: 'model' },
      { field: 'price' }
    ]);

  const authenticatorComponents = {
    Header() {
      const { tokens } = useTheme();
      return (
        <View textAlign="center" padding={tokens.space.large}>
        <Image
          alt="Ask This Home logo"
          src="/400dpiLogo.png"
        />
      </View>
      );
    }
  }


  return (
    <Authenticator 
      components={authenticatorComponents} 
      hideSignUp={true}
    >
      {({ signOut, user }) => (
      <>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="True" />
        <link
      href="https://fonts.googleapis.com/css2?family=Inter:slnt,wght@-10..0,100..900&display=swap"
      rel="stylesheet"
        />
        <NavBar />
        <FAQItem overrides={{
            "Title":{"children":"Hello World"},
            "Paragraph":{"children":"Ask This Home"}
          }}></FAQItem>

        <Text>Current user is {user.attributes.email}</Text>

        <ClassOwner />
        <Home />
        <IntentResponse />
        <div className="ag-theme-alpine" style={{height: 400, width: 600}}>
            <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}>
            </AgGridReact>
        </div>
      </>
      )}
    </Authenticator>
  );
}

